import { SelectedMarkerIndoorStand } from 'components/site/general/singleSelect/SelectedMarkerV2/SelectedMarkerIndoorStand';
import { SelectedMarkerV2Direction } from 'components/site/general/singleSelect/SelectedMarkerV2/SelectedMarkerV2Direction';
import { SelectedMarkerV2Icon } from 'components/site/general/singleSelect/SelectedMarkerV2/SelectedMarkerV2Icon';
import { SelectedMarkerV2Image } from 'components/site/general/singleSelect/SelectedMarkerV2/SelectedMarkerV2Image';
import { SelectedMarkerV2Line } from 'components/site/general/singleSelect/SelectedMarkerV2/SelectedMarkerV2Line';
import { SelectedMarkerV2Polygon } from 'components/site/general/singleSelect/SelectedMarkerV2/SelectedMarkerV2Polygon';
import { SelectedMarkerV2Route } from 'components/site/general/singleSelect/SelectedMarkerV2/SelectedMarkerV2Route';
import { SelectedMarkerV2VariantIcon } from 'components/site/general/singleSelect/SelectedMarkerV2/SelectedMarkerV2VariantIcon';
import { SelectedMarkerV2Wall } from 'components/site/general/singleSelect/SelectedMarkerV2/SelectedMarkerV2Wall';
import { useMarkerVisibility } from 'hooks/map/useMarkerVisibility';
import { useWorldMarker } from 'hooks/marker/useWorldMarker';
import { isV2Marker } from 'react-give-me-map';

interface Props {
    markerId: string;
}

export const SelectedMarkerV2 = (props: Props) => {
    const worldMarker = useWorldMarker();
    const selectedMarker = worldMarker.getMarkerById(props.markerId);
    const markerVisibility = useMarkerVisibility();

    if (
        !selectedMarker ||
        !markerVisibility.isMarkerVisibleInEdit(selectedMarker) ||
        !isV2Marker(selectedMarker)
    ) {
        return null;
    }

    switch (selectedMarker.elementType) {
        case 'v2/icon':
            return <SelectedMarkerV2Icon markerId={props.markerId} />;
        case 'v2/variant_icon':
            return <SelectedMarkerV2VariantIcon markerId={props.markerId} />;
        case 'v2/line':
            return <SelectedMarkerV2Line markerId={props.markerId} />;
        case 'v2/polygon':
            return <SelectedMarkerV2Polygon markerId={props.markerId} />;
        case 'v2/wall': {
            return <SelectedMarkerV2Wall markerId={props.markerId} />;
        }
        case 'v2/image':
            return <SelectedMarkerV2Image markerId={props.markerId} />;
        case 'direction':
            return <SelectedMarkerV2Direction markerId={props.markerId} />;
        case 'v2/text':
            return <SelectedMarkerV2Image markerId={props.markerId} />;
        case 'v2/route':
            return <SelectedMarkerV2Route markerId={props.markerId} />;
        case 'indoor_stand':
            return <SelectedMarkerIndoorStand markerId={props.markerId} />;
    }
};
